import Watermelon from './Watermelon'

export default Watermelon
